const warehousepurchaseDt = require('./warehousepurchase-dt')
const warehousepurchasePage = require('./warehousepurchase-page')

export function start(detail){   //console.log('goku-dt 5>', detail)
         
      obj[detail.elem].start(detail)

}/**/

const obj = {
   
      dt:            { start: (detail)=>{  warehousepurchaseDt.start(detail)             }},
      page:          { start: (detail)=>{  warehousepurchasePage.start(detail)           }},

}








